import { checkPermission } from "../../../utils/PermissionUtils";

const SettingsMenuTypes = {
    NOTIFICATION_SETTINGS: {
        id: "notifications",
        group: "myaccount",
        path: "notifications",
        label: "Notifications",
        tabs: [],
        isPublic: true,
        implemented: true,
        isAuthorized: (that) => {
            return true;
        },
    },
    COMPANY: {
        id: "company",
        group: "General",
        path: "company",
        label: "Company Settings",
        tabs: [],
        implemented: true,
        isAuthorized: (that) => {
            return that.checkPermission("setting.get");
        },
    },
    FEATURES: {
        id: "features",
        group: "General",
        path: "features",
        label: "Features",
        tabs: [],
        implemented: true,
        isAuthorized: (that) => {
            return that.checkPermission("setting.get");
        },
    },
    LANGUAGE: {
        id: "language",
        group: "General",
        path: "language",
        label: "Language",
        tabs: [],
        implemented: true,
        isAuthorized: (that) => {
            return that.checkPermission("setting.get");
        },
    },
    WALLET: {
        id: "wallet",
        group: "General",
        path: "wallet",
        label: "My Wallet",
        tabs: [],
        implemented: true,
        isAuthorized: (that) => {
            return that.checkPermission("setting.get");
        },
    },
    AUDIT_LOGS: {
        id: "auditlogs",
        group: "General",
        path: "audit-logs",
        label: "Audit Logs",
        tabs: [],
        implemented: true,
        isAuthorized: (that) => {
            return that.checkPermission("setting.get");
        },
    },
    BUBBLE_SETTINGS: {
        id: "bubble-settings",
        group: "Chat",
        path: "bubble-settings",
        label: "Bubble Settings",
        tabs: [],
        implemented: true,
        isAuthorized: (that) => {
            return that.checkPermission("setting.get");
        },
    },
    BUBBLE_DROPDOWN: {
        id: "bubble-actions",
        group: "Chat",
        path: "bubble-actions",
        label: "Bubble Actions",
        tabs: [],
        implemented: true,
        isAuthorized: (that) => {
            return that.checkPermission("setting.get");
        },
    },
    THEME_SETTINGS: {
        id: "theme-settings",
        group: "Chat",
        path: "theme-settings",
        label: "Chat Theme Settings",
        tabs: [],
        implemented: true,
        isAuthorized: (that) => {
            return that.checkPermission("setting.get");
        },
    },
    VISITOR_LOGIN_FORM: {
        id: "visitorLoginForm",
        group: "Chat",
        path: "visitor-login-form",
        label: "Visitor Login Form",
        tabs: [],
        implemented: true,
        isAuthorized: (that) => {
            return that.checkPermission("setting.get");
        },
    },
    VISITOR_ATTRIBUTE: {
        id: "visitorAttribute",
        group: "Chat",
        path: "visitor-attribute",
        label: "Visitor Attribute",
        tabs: [],
        implemented: true,
        isAuthorized: (that) => {
            return that.checkPermission("setting.get");
        },
    },
    AUTO_ASSIGN: {
        id: "auto_assign",
        group: "Chat",
        path: "auto-assign",
        label: "Auto Assign Settings",
        tabs: [],
        implemented: true,
        isAuthorized: (that) => {
            return that.checkPermission("setting.get");
        },
    },
    TIMING_SETTINGS: {
        id: "timing_settings",
        group: "Timings",
        path: "timings-settings",
        label: "Chat Timing Settings",
        tabs: [],
        implemented: true,
        isAuthorized: (that) => {
            return that.checkPermission("setting.get");
        },
    },
    AVAILABILITY: {
        id: "availability",
        group: "Timings",
        path: "availability",
        label: "Availability",
        tabs: [],
        implemented: true,
        isAuthorized: (that) => {
            return that.checkPermission("setting.get");
        },
    },
    WEBSITE_INTEGRATION: {
        id: "website-integration",
        group: "Integration",
        path: "website-integration",
        label: "Website Integration",
        tabs: [],
        implemented: true,
        isAuthorized: (that) => {
            return that.checkPermission("setting.get");
        },
    },
    DEVELOPER: {
        id: "developer",
        group: "Integration",
        path: "developer",
        label: "API Access",
        tabs: [],
        implemented: true,
        isAuthorized: (that) => {
            return that.checkPermission("setting.get");
        },
    },
};

export default SettingsMenuTypes;
